import {Component, OnInit} from '@angular/core';
import {TeamService} from '@core/services/team.service';
import {PickerItem} from '@lib-modules/picker/components/picker-item/picker-item.component';
import {AdCampaignPlacement} from '@api/models/ad-campaign/ad-campaign-placement';
import {EntityType} from '@lib/models/entity/entity-type';
import {AdCampaignService} from '@components/ad-campaign/services/ad-campaign.service';
import {NewsContentType} from '@lib-modules/cards/services/news-card/news-card.service';

@Component({
  selector: 'app-team-news',
  templateUrl: './team-news.component.html',
  styleUrls: ['./team-news.component.scss'],
})

export class TeamNewsComponent implements OnInit {

  public newsType = NewsContentType.EntityNews;
  public entityType = EntityType.Team;
  public item: PickerItem;

  public constructor(public teamService: TeamService,
                     private adCampaignService: AdCampaignService) { }

  public ngOnInit() {
    this.adCampaignService.setPlacement(AdCampaignPlacement.News);
    this.item = this.teamService.currentTeam.getAsPickerItem();
  }
}
